// #region imports

// --- Angular
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

// --- HS Code
import { NotificationModel, NotificationTypes } from '../../../models';

// #endregion

@Component({
  selector: 'hs-notification-list-item',
  templateUrl: './notification-list-item.component.html',
  styleUrls: ['./notification-list-item.component.scss']
})
export class NotificationListItemComponent implements OnChanges {
  @Input() notificationTypes = NotificationTypes;
  @Input() notification: NotificationModel | null = null;
  @Input() markAsReadLabel: string = '';
  @Input() downloadLabel: string = '';

  @Output() view = new EventEmitter<NotificationModel>();
  @Output() remove = new EventEmitter<NotificationModel>();

  notificationTitle: string = '';
  notificationHighlightBody: string = '';
  notificationDate: Date = new Date();
  notificationType: NotificationTypes = NotificationTypes.unknown;
  notificationImage: string = '';

  ngOnChanges(changes: SimpleChanges): void {
      if (changes && changes['notification'] && changes['notification'].currentValue) {
        this.notificationTitle = this.notification?.title || '';
        this.notificationHighlightBody = this.notification?.highlightBody || '';
        this.notificationDate = this.notification?.dateOfNotification || new Date();
        this.notificationType = this.notification?.type || NotificationTypes.unknown;
        this.notificationImage = this.notification?.image || '';
      }
  }

  onView(event: Event, notification: NotificationModel | null): void {
    if (!notification) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.view.emit(notification);
  }

  onRemove(event: Event, notification: NotificationModel | null): void {
    if (!notification) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.remove.emit(notification);
  }
}
